import React, { Fragment, useContext } from 'react';
import { Image } from '../../AbstractElements';
import {AlignLeft } from 'react-feather';
import CustomizerContext from '../../_helper/Customizer';
import { Link } from 'react-router-dom';
import darklogo from '../../assets/images/logo/dark-logog.svg'
import whitelogo from '../../assets/images/logo/logo-white.svg'

const SidebarLogo = () => {
  const { mixLayout, toggleSidebar,toggleIcon } = useContext(CustomizerContext);
  return (
    <Fragment>
      <div className="logo-wrapper">
        {mixLayout?
          <Link to={`${process.env.PUBLIC_URL}/dashboard/default/`}>
            <Image attrImage={{ className: "img-fluid for-light", src: darklogo, alt: "",style:{width:'130px',height:'60px'} }} />
          </Link>
          :
          <Link to={`${process.env.PUBLIC_URL}/dashboard/default/`}>
            <Image attrImage={{ className: "img-fluid for-dark ", src: whitelogo, alt: "" ,style:{width:'130px',height:'60px'}}} />
          </Link>
        }
        <div className="back-btn" onClick={() => toggleSidebar(!toggleIcon)}  style={{ marginTop: "-43px",marginRight:'-6px' ,zIndex:1}}><i className="fa fa-angle-left"></i></div>
        <div className="toggle-sidebar" onClick={() => toggleSidebar(!toggleIcon)}>
          <AlignLeft className={`status_toggle middle`} id="sidebar-toggle" />
        </div>
      </div> 
    </Fragment >   
  );
};

export default SidebarLogo;